import { parseIframeComponentCore, extractProportions } from './component.iframe.core.js';

const parseTaskEngineLinkComponent = (node) => {
  const src = node.getAttribute("src");
  const coreConfig = parseIframeComponentCore(node);
  if (!src || !coreConfig) {
    return null;
  }
  const displayData = {
    proportions: extractProportions(node.getAttribute("aspectRatio"), {
      width: 0,
      height: 0
    }),
    minSize: extractProportions(node.getAttribute("minSize"), {
      width: 0,
      height: 0
    }),
    maxSize: extractProportions(node.getAttribute("maxSize"), {
      width: 0,
      height: 0
    }),
    fixedHeight: false,
    src
  };
  return {
    ...coreConfig,
    displayData,
    options: {
      ...coreConfig.options,
      autoActivate: false
    }
  };
};

export { parseTaskEngineLinkComponent };
//# sourceMappingURL=component.iframe.task-engine-link.js.map
